import { SelectAuthenticator } from './/Base/SelectAuthenticator';
export class SelectAuthenticatorAuthenticate extends SelectAuthenticator {
}
SelectAuthenticatorAuthenticate.remediationName = 'select-authenticator-authenticate';
